import React, { forwardRef } from 'react';
import {
  Textarea as ChakraTextarea,
  TextareaProps,
  useStyleConfig,
} from '@chakra-ui/react';

interface Props extends Omit<TextareaProps, `css`> {
  label?: string;
  name?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(
  ({ label, name, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`Textarea`);

    return (
      <ChakraTextarea
        id={name}
        name={name}
        ref={ref}
        __css={styles}
        {...props}
      />
    );
  }
);
export type { Props as TextareaProps };
